import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import * as moment from 'moment';
import { AxUiService } from 'src/app/services/ax-ui.service';
import { ScannerService } from 'src/app/services/scanner.service';
import { WorkEvent, WorkEventsService, WorkMyService, WorkUploadsService } from '../../../_generated/work-rest-api';

@Component({
  selector: 'app-events',
  templateUrl: './events.page.html',
  styleUrls: ['./events.page.scss'],
})
export class EventsPage implements OnInit {
  public eventsFuture: WorkEvent[] = [];
  public eventsPast: WorkEvent[] = [];
  public segment: 'future' | 'past' = 'future';

  constructor(
    private router: Router,
    private title: Title,
    private store: Store,
    private scannerService: ScannerService,
    private axUploadsService: WorkUploadsService,
    private axUiService: AxUiService,
    private axEventsService: WorkEventsService,
    private axMyService: WorkMyService,
  ) {
  }

  async ngOnInit() {
    await this.loadData();
  }

  ionViewDidEnter() {
    this.title.setTitle(`Veranstaltungen`);
  }

  /**
   * Initial data load. Can be repeated, e.g. via ion-refresher.
   *
   * @param refresherEvent
   */
  public async loadData(refresherEvent?) {
    const allEvents = await this.axMyService.myEventsV1ControllerFindAll({ onlyFutureEvents: false }).toPromise();
    this.eventsFuture = allEvents.filter(event => moment(event.endAt).isAfter(moment()));
    this.eventsPast = allEvents.filter(event => moment(event.endAt).isBefore(moment()));
    this.onLoadDataComplete(refresherEvent);
  }

  public openEventDetail(eventItem: WorkEvent) {
    this.router.navigate([`/global/event-detail/${eventItem.id}`]).then();
  }

  /**
   * After Loading completed.
   *
   * @param refresherEvent
   * @private
   */
  private onLoadDataComplete(refresherEvent): void {
    if (refresherEvent) {
      refresherEvent.target.complete();
    }
  }
}
